<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">资产明细</span>
  </a-card>
  <SmallSquare :content="$route.query.name" :padding='true' />
  <a-card :bordered="false">
    <a-tabs v-model:activeKey="activeKey" @change='tabChange'>
      <a-tab-pane :key='1' tab="品牌优惠券" :disabled='activeKey !== 1 && listLoading'></a-tab-pane>
      <a-tab-pane :key='2' tab="门店优惠券" :disabled='activeKey !== 2 && listLoading'></a-tab-pane>
      <a-tab-pane :key='3' tab="礼品" :disabled='activeKey !== 3 && listLoading'></a-tab-pane>
    </a-tabs>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
      :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='coupon_name' v-if='activeKey !== 3'>
        <a-input style="width: 270px" v-model:value="search.coupon_name" allowClear :placeholder="'请输入优惠券名称进行搜索'" />
      </a-form-item>
      <a-form-item label="关键词" name='exchange_name' v-if='activeKey == 3'>
        <a-input style="width: 270px" v-model:value="search.exchange_name" allowClear :placeholder="'请输入礼品名称进行搜索'" />
      </a-form-item>
      <a-form-item label="" name='' v-if='activeKey !== 3'>
        <a-select v-model:value="search.coupon_type" :style="{width:'180px'}" placeholder="请选择">
          <a-select-option value="">全部优惠券类型</a-select-option>
          <a-select-option :value="2">现金券</a-select-option>
          <a-select-option :value="3">代金券</a-select-option>
          <a-select-option :value="1">折扣券</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="" name='' v-if='activeKey !== 3'>
        <a-select v-model:value="search.source_type" :style="{width:'180px'}" placeholder="请选择">
          <a-select-option value="">全部派发渠道</a-select-option>
          <a-select-option :value="1" v-if='activeKey == 1'>会员权益</a-select-option>
          <a-select-option :value="3" v-if='activeKey == 1'>直接发放</a-select-option>
          <a-select-option :value="4" v-if='activeKey == 1'>扫码活动</a-select-option>
          <a-select-option :value="2" v-if='activeKey == 1'>品牌派券活动</a-select-option>
          <a-select-option :value="5" v-if='activeKey == 2'>云店派券活动</a-select-option>
          <a-select-option :value="6" v-if='activeKey == 2'>优惠券礼包</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <lookAssets :data='data' :columns='columns' :listLoading='listLoading' :keyRow='keyRow'></lookAssets>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { getAssetsMoreGift,getAssetsMoreCoupon } from "@/api/reimbursement";
  import { iscode } from "@/utils/app";
  import lookAssets from './components/lookAssets'
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    type: '',
    source_type: '',
    coupon_type: '',
    coupon_name: ''
  };
  export default {
    components: { lookAssets, LeftOutlined },
    setup(props) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
    const $route = inject("$route");
      const state = reactive({
        listLoading: false,
        keyRow:'',
        total: 1,
        activeKey: 1,
        columns: [],
        couponColumns: [
          {
            title: "优惠券名称",
            dataIndex: "coupon_name",
            key: "coupon_name",
          },
          {
            title: "优惠券类型",
            dataIndex: "coupon_type",
            key: "coupon_type"
          },
          {
            title: "券号",
            dataIndex: "coupon_sn",
            key: "coupon_sn",
          },
          {
            title: "派发渠道",
            dataIndex: "source_type",
            key: "source_type ",
          },
          {
            title: "抵扣金额（元）",
            dataIndex: "coupon_price",
            key: "coupon_price",
          }
        ],
        giftColumns: [
          {
            title: "礼品名称",
            dataIndex: "exchange_name",
            key: "exchange_name",
            slots: { customRender: "exchange_name" },
          },
            {
            title: "规格",
            dataIndex: "exchange_spec_value",
            key: "exchange_spec_value",
            customRender:function({record}){
              return record.exchange_spec_value || '-'
            }
          },
          {
            title: "最多报销数量（个）",
            dataIndex: "num",
            key: "num",
          }
        ]
      })
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        getList()
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        getList()
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        getList()
      };
      const getCoupon = async (values) => {
        state.listLoading = true;
        let res = await getAssetsMoreCoupon({ ...values,store_id: $route.query.id, type: $route.query.type == 'dealer' ? 2 : 1, coupon_sourece_type: state.activeKey }).then(res => res.data).catch(error => error);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        setTimeout(()=>{
          state.listLoading = false;
        },100)
      };
      const getGift = async (values) => {
        state.listLoading = true;
        let res = await getAssetsMoreGift({ ...values,store_id: $route.query.id, type: $route.query.type == 'dealer' ? 2 : 1 }).then(res => res.data).catch(error => error);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        setTimeout(()=>{
          state.listLoading = false;
        },100)
      };
      //切换面板
      const tabChange = (e) =>{
        search.value = {...defSearch}
        getList();
      }
      const getList = () =>{
        data.value = []
        state.columns = state.activeKey == 3 ? state.giftColumns : state.couponColumns
        state.keyRow = state.activeKey == 3 ? 'exchange_name':'coupon_sn'
        if (state.activeKey !== 3) {
          getCoupon(search.value)
        } else {
          getGift(search.value)
        }
      }
      onMounted(() => {
        getList()
      });
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        tabChange
      }
    }
  }
</script>